// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__qEgAW","skipLink":"Layout_skipLink__xUB4Q","main":"Layout_main__9TUtC"};